import * as yup from 'yup';
import { MEDIA_URL_REGEXP } from 'constants/regexp';

export const rules = yup.object().shape({
  url: yup.string()
    .required('This field is required')
    .matches(MEDIA_URL_REGEXP, 'Url is incorrect'),
});
